<template>
    <div class="main-footer text-center">
        <div class="container">
          <div class="row row-sm">
            <div class="col-md-12">
              <span>نسخه : 1.0.0</span>
            </div>
          </div>
        </div>
      </div>    
</template>

<script>
export default {
    name: 'Footer'
}
</script>